import React, { useEffect, useState } from "react";
import { ethers } from "ethers";
import { WebConfig } from "../../Config/WebConfig";
import simuleCoin from "../../assets/images/home/sils.png";

const fallbackRewards = "6,479,376";

const formatTokenAmount = (value) =>
  Number(value).toLocaleString(undefined, { maximumFractionDigits: 6 });

const TokenStats = () => {
  const [loading, setLoading] = useState(true);
  const [totalRewards, setTotalRewards] = useState(null);

  useEffect(() => {
    let active = true;

    const loadTokenStats = async () => {
      setLoading(true);

      try {
        const provider = new ethers.providers.JsonRpcProvider(WebConfig.rpcUrl);
        const token = new ethers.Contract(
          WebConfig.simuleTokenAddress,
          WebConfig.simuleTokenABI,
          provider
        );

        const totalSupply = await token.totalSupply();
        if (active) {
          setTotalRewards(
            formatTokenAmount(ethers.utils.formatUnits(totalSupply, 18))
          );
        }
      } catch (error) {
        console.error("Unable to load SIMULE token statistics:", error);
        if (active) {
          setTotalRewards(null);
        }
      } finally {
        if (active) setLoading(false);
      }
    };

    loadTokenStats();
    return () => {
      active = false;
    };
  }, []);

  const displayedRewards = totalRewards || fallbackRewards;

  return (
    <section className="token-stats-section" aria-label="SIMULE token statistics">
      <div className="container">
        <div className="token-stats-grid">
            <article className="token-stat-card">
              <div className="token-stat-heading">
              <div className="token-stat-icon" aria-hidden="true">
                <img src={simuleCoin} alt="" />
              </div>
              <div className="token-stat-content">
                  <span className="token-stat-eyebrow">SIMULE ECOSYSTEM</span>
                  <h2>Total rewards generated</h2>
                </div>
              </div>

              <div className="token-stat-metric" aria-live="polite">
                {loading ? (
                  <div className="token-stat-skeleton" aria-label="Loading token statistic" />
                ) : (
                  <div className="token-stat-value">
                    <strong>{displayedRewards}</strong>
                    <span>SIMULE</span>
                  </div>
                )}
              </div>

              <div className="token-stat-summary">
                <span className="token-stat-status">
                  <i aria-hidden="true" />
                  Live reward total
                </span>
                <p>Generated through Digital Land minting on Simule.</p>
              </div>
            </article>
        </div>
      </div>
    </section>
  );
};

export default TokenStats;
